export const formatResultCount = (total: number, isTotalExact: boolean) =>
  `${total}${isTotalExact ? "" : "+"} ${total === 1 && isTotalExact ? "result" : "results"}`;
